/**
 * @enum PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD
 * @type {{YEARLY: string, MONTHLY: string}}
 */
export const PHOTO_MANAGER_SUBSCRIPTION_BILLING_PERIOD = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

/**
 * PhotoManagerSubscription features.
 *
 * @type {string[]}
 */
export const PHOTO_MANAGER_SUBSCRIPTION_FEATURES = [
  'QR code, SMS & Roster-based onboarding',
  'Custom, branded prints (lab integrations)',
  'Facial & jersey recognition-powered proof delivery',
  'Real-time sales reporting and analytics',
  'FaceBlocker patented copyright protection',
  'SMS & Email re-marketing',
  'Mobile-optimized checkout & dropshipping',
  '1TB photo & video storage (with affordable upgrades)',
];

/**
 * Checks if an Account is eligible for a PhotoManager subscription trial.
 *
 * @param {Object} [account] The Account.
 * @returns {*}
 */
export const isEligibleForPhotoManagerFreeTrial = account => {
  return (
    !account?.pro_settings?.has_free_photo_manager &&
    account?.photo_manager_subscription_free_trial_enabled
  );
};
